import { Box } from '@mui/material'

import { DadosEmpresa } from './DadosEmpresa'
import { DadosEndereco } from './DadosEndereco'
import { DadosResponsavel } from './DadosResponsavel'

export function DadosCadastrais() {
    return (
        <Box component="section" id="dados-cadastrais">
            <DadosEmpresa />
            <DadosResponsavel />
            <DadosEndereco />
        </Box>
    )
}
